import {
  init as AMPLITUDE_INIT,
  Identify as AMPLITUDE_IDENTIFY_CLASS,
  identify as AMPLITUDE_IDENTIFY_FUNCTION,
} from '@amplitude/analytics-browser';

export const init = AMPLITUDE_INIT;
export const Identify = AMPLITUDE_IDENTIFY_CLASS;
export const identify = AMPLITUDE_IDENTIFY_FUNCTION;
